export default __webpack_public_path__ + "static/media/ossscreen3.41635b64.png";